import { useSelector } from 'react-redux';
import { AuthEntity } from '_entities';

const { getUserSubdomain } = AuthEntity.selectors;

function IsMdAccount() {
  const userState = useSelector(getUserSubdomain);
  const mdAccountStates = ['md'];
  return mdAccountStates.includes(userState);
}

export default IsMdAccount;
